module.exports = __webpack_public_path__ + "img/CellHost-1.0312c074.png";